import MinimalTextArea from '@sophocles/components/FormFields/MinimalTextArea/MinimalTextArea';

export default MinimalTextArea;
